// Search Contentful text strings for variables
// inside double-brackets,for example -> [[varibale_name]]
const shortCodeRegEx = /\[\[[^\]]*\]\]/g;

const dyanmicShortCodeText = ({ textToSearch, replaceDictLookup = {} }) => {
  return textToSearch?.replace(shortCodeRegEx, (string) => {
    const variableName = string.replace(/\[|\]/g, "");
    const replacement = replaceDictLookup[variableName];

    return replacement;
  });
};

export default dyanmicShortCodeText;
